import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Componente de paginación mejorado.
 * @param {object} props
 * @param {() => void} props.onNext - Función para ir a la página siguiente.
 * @param {() => void} props.onPrevious - Función para ir a la página anterior.
 * @param {boolean} props.canNext - Booleano que indica si se puede ir a la página siguiente.
 * @param {boolean} props.canPrevious - Booleano que indica si se puede ir a la página anterior.
 * @param {number} props.currentPage - El número de la página actual.
 * @param {number} props.totalItems - El número total de elementos.
 * @param {number} props.itemsPerPage - El número de elementos por página.
 * @param {(value: number) => void} props.onItemsPerPageChange - Función para cambiar los elementos por página.
 */
const Pagination = ({
  onNext,
  onPrevious,
  canNext,
  canPrevious,
  currentPage,
  totalItems,
  itemsPerPage,
  onItemsPerPageChange,
}) => {
  if (totalItems === 0) {
    return null;
  }

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div style={{ width: '100%' }}>
      <hr />
      <div className="pagination-controls" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '8px 0' }}>
        <div className="pagination-rows-per-page">
          <label htmlFor="rows-per-page">Filas por página:</label>
          <select
            id="rows-per-page"
            value={itemsPerPage}
            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
            className="pagination-select"
          >
            <option value={20}>20</option>
            <option value={60}>60</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="pagination-info" style={{ margin: '0 16px' }}>
          {startItem} – {endItem} de {totalItems}
        </div>
        <div className="pagination-nav">
          <button onClick={onPrevious} disabled={!canPrevious} className="pagination-button">
            <ChevronLeft size={20} />
          </button>
          <button onClick={onNext} disabled={!canNext} className="pagination-button">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;